<template>
  <div class="edit-env">
    <div
      style="width: fit-content;"
      class="d-flex align-center link-default mb-4"
      @click="cancel"
    >
      <apio-icon
        class="mr-1"
        size="16"
        lightModeColour="cyan"
        name="chevron-left"
      />Back
    </div>
    <HeaderPanel header-icon="ui-edit-apioshade3" :header-text="`Environment Variables`" />
    <div class="edit-env__import-export">
      <apio-button
        class="mr-2"
        button-text-size="tiny"
        button-size="small"
        button-type="secondary"
        button-icon=""
        @click.native="saveEnv"
        @mouseover.native="onSecondaryButtonMouseOver('save')"
        @mouseout.native="onSecondaryButtonMouseOut('save')"
      >
        SAVE
        <apio-icon
          class="ml-1"
          name="ui-save"
          :lightModeColour="secondaryButtonIconColours.save.color"
          :darkModeColour="secondaryButtonIconColours.save.color"
        />
      </apio-button>

      <apio-button
        class="mr-2"
        button-text-size="tiny"
        @click.native="
          uploadMessage = 'Please choose a JSON program file';
          uploadJSONDialog = true;
        "
        button-size="small"
        button-type="secondary"
        @mouseover.native="onSecondaryButtonMouseOver('import')"
        @mouseout.native="onSecondaryButtonMouseOut('import')"
        >IMPORT
        <apio-icon
          class="ml-1"
          name="ui-upload"
          :lightModeColour="secondaryButtonIconColours.import.color"
          :darkModeColour="secondaryButtonIconColours.import.color"
      /></apio-button>

      <apio-button
        button-text-size="tiny"
        @click.native="downloadJSON"
        button-size="small"
        button-type="secondary"
        @mouseover.native="onSecondaryButtonMouseOver('export')"
        @mouseout.native="onSecondaryButtonMouseOut('export')"
        >EXPORT
        <apio-icon
          class="ml-1"
          name="ui-download"
          :lightModeColour="secondaryButtonIconColours.export.color"
          :darkModeColour="secondaryButtonIconColours.export.color"
      /></apio-button>
    </div>

    <div class="edit-env__content">
      <EditArrayMap v-model="variablesArray" />

      <div class="edit-env__actions">
        <apio-button
          class="mr-2"
          button-type="secondary"
          button-size="medium"
          @click.native="cancel"
        >
          Cancel
        </apio-button>
        <apio-button button-size="medium" @click.native="saveEnv">
          Save Environments
        </apio-button>
      </div>
    </div>

    <v-dialog max-width="600" v-model="uploadJSONDialog">
      <v-card>
        <v-toolbar flat color="apioshade3" class="white--text h2 mb-6">
          <div class="white--text run-step__title">Upload JSON file</div>
          <v-spacer></v-spacer>
          <apio-button
            button-type="get-started"
            button-size="small"
            @click="uploadJSONDialog = false"
            >Close
            <apio-icon
              class="ml-2"
              size="16"
              name="cross"
              lightModeColour="white"
              darkModeColour="white"
          /></apio-button>
        </v-toolbar>
        <div class="px-4" id="loadscreen" hide-footer title="Upload JSON File">
          <p>
            The uploaded JSON program code file will replace current code in the
            editor, will not be automatically saved.
          </p>
          <label>Upload:</label>
          <input type="file" @change="readFile" />
          <br />
          <div class="mt-2">{{ uploadMessage }}</div>
        </div>
        <v-card-actions />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "EditEnvironment",
  components: {
    EditArrayMap: () => import("@/components/EditArrayMap"),
    HeaderPanel: () => import("@/components/HeaderPanel/HeaderPanel.vue"),
  },
  data: () => ({
    name: "",
    envname: "",
    uploadJSONDialog: false,
    uploadMessage: "",
    secondaryButtonIconColours: {
      save: {
        color: "cyan",
        light: {
          normal: "cyan",
          hover: "black",
        },
        dark: {
          normal: "cyan",
          hover: "cyan",
        },
      },
      import: {
        color: "cyan",
        light: {
          normal: "cyan",
          hover: "black",
        },
        dark: {
          normal: "cyan",
          hover: "cyan",
        },
      },
      export: {
        color: "cyan",
        light: {
          normal: "cyan",
          hover: "black",
        },
        dark: {
          normal: "cyan",
          hover: "cyan",
        },
      },
    },
  }),
  computed: {
    variablesObject() {
      return this.$store.state.enveditor.variables;
    },
    variablesArray: {
      get() {
        return this.$store.state.enveditor.variablesArray;
      },
      set(newValue) {
        this.$store.dispatch("updateVariables", newValue);
      },
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  methods: {
    cancel() {
      this.$router.push(`/build?c=${this.$route.query.c}&i=${this.$route.query.i}`);
    },
    onSecondaryButtonMouseOver(index) {
      return (this.secondaryButtonIconColours[
        index
      ].color = this.secondaryButtonIconColours[index][this.theme].hover);
    },
    onSecondaryButtonMouseOut(index) {
      return (this.secondaryButtonIconColours[
        index
      ].color = this.secondaryButtonIconColours[index][this.theme].normal);
    },
    saveEnv() {
      this.$store.dispatch("saveVariables", {
        clientHash: this.$route.query.c,
        appHash: this.$route.query.a,
        interfaceHash: this.$route.query.i,
        variables: this.variablesObject,
      });
      this.$router.push(`/build?c=${this.$route.query.c}&i=${this.$route.query.i}`);
    },
    downloadJSON() {
      this.downloadString(
        JSON.stringify(
          this.$store.state.enveditor.variablesArray,
          undefined,
          2
        ),
        "application/json",
        "env_" + this.envname + ".json"
      );
    },
    downloadString(text, fileType, fileName) {
      let blob = new Blob([text], {
        type: fileType,
      });

      let a = document.createElement("a");
      a.download = fileName;
      a.href = URL.createObjectURL(blob);
      a.dataset.downloadurl = [fileType, a.download, a.href].join(":");
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(function () {
        URL.revokeObjectURL(a.href);
      }, 1500);
    },
    readFile(evt) {
      let self = this;
      if (!window.FileReader) return; // Browser is not compatible

      let reader = new FileReader();

      reader.onload = function (evt) {
        if (evt.target.readyState !== 2) return;
        if (evt.target.error) {
          alert("Error while reading file");
          return;
        }
        let res = JSON.parse(evt.target.result);
        self.$store.dispatch("updateVariables", res);
        self.uploadmsg =
          "The JSON program file has been read, you can close the form by pressing [esc] or clicking out.";
      };

      reader.readAsText(evt.target.files[0]);
    },
  },
  async created() {
    this.envname = this.$route.query.u;
    this.name = this.$route.query.p;
    this.$store.dispatch("fetchVariables", {
      clientHash: this.$route.query.c,
      appHash: this.$route.query.a,
      interfaceHash: this.$route.query.i,
    });
  },
};
</script>

<style lang="scss" scoped>
.edit-env {
  margin: 0 32px 16px 32px;

  @media (max-width: 1024px) {
    margin: 0 20px 12px 20px;
  }

  &__actions,
  &__import-export {
    display: flex;
    justify-content: flex-end;
  }

  &__import-export {
    margin-bottom: 16px;
    @media (max-width: 1024px) {
      margin-bottom: 8px;
    }
  }
}
</style>
